document.addEventListener('DOMContentLoaded', function () {
  const tooltips = document.querySelectorAll('.product-message__tooltip');

  tooltips.forEach(tooltip => {
    const closeButton = tooltip.querySelector('.product-message__tooltip-close');
    const tooltipContent = tooltip.querySelector('.product-message__tooltip-content');

    if (closeButton && tooltipContent) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Add a class to hide the tooltip
        tooltip.classList.add('tooltip-closed');
      });

      // Reset the closed state on hover
      tooltip.addEventListener('mouseenter', function() {
        this.classList.remove('tooltip-closed');
      });
    }
  });
});
